import React from "react";

import { CloseOutlined, PlusOutlined } from "@ant-design/icons";

import "./TrendChartPill.css";

const TrendChartPill = ({
  testName, color, backgroundColor, isSelected, onClick,
}) => (
  <button
    type="button"
    className={`TrendChartPill ${isSelected ? "TrendChartPill--active" : "TrendChartPill--inactive"}`}
    style={isSelected ? { borderColor: color, color, backgroundColor } : undefined}
    onClick={() => onClick(testName)}
    aria-pressed={isSelected}
  >
    <span className="TrendChartPill__Label">{testName}</span>
    {isSelected ? (
      <CloseOutlined className="TrendChartPill__Icon" aria-hidden />
    ) : (
      <PlusOutlined className="TrendChartPill__Icon" aria-hidden />
    )}
  </button>
);

export default TrendChartPill;
